// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3G0mb","label":"styles_label__3mlh5"};